import styled from "styled-components/macro";

export const ItemLi = styled.li<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  background: ${(props) =>
    props.isActive ? props.theme.colors.text : "transparent"};
  width: 100%;
  padding: 16px 8px;
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  position: relative;
  &:hover {
    cursor: pointer;
  }
  & > #dots:hover {
    background: ${(props) => props.theme.colors.bgDark};
    border-radius: 50%;
    cursor: pointer;
  }
  & > p {
    color: ${(props) =>
    props.isActive ? props.theme.colors.bgBody : props.theme.colors.text};
    font-size: 16px;
    line-height: 21px;
    font-weight: 600;
    padding: 0 8px;
    flex: 1;
    margin: 0;
    white-space: nowrap;
    overflow-x: hidden;
    max-width: 130px;
    & div {
      display: flex;
      flex-direction: column;
      & span:last-child {
        color: ${(props) => props.theme.colors.textDimmed};
        font-size: 11px;
      }
    }
    @media ${(props) => props.theme.media.phone} {
      max-width: 100%;
    }
  }
  & > #dots {
    align-self: center;
  }
  & > img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border-width: 1px;
    border-style: solid;
    border-color: ${(props) =>
    props.isActive ? props.theme.colors.place : props.theme.colors.border};
  }
`;

export const DropDownMenu = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border-radius: 4px;
  background: #ffffff;
  z-index: 10;
  color: ${(props) => props.theme.colors.text};
  display: ${(props) => (props.isVisible ? "block" : "none")};
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  & > ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
    height: 100%;
    & > li:nth-last-child(1) {
      padding: 5px 12px 10px;
    }
    & > li {
      padding: 10px 12px 5px;
      &:hover {
        background: rgba(0, 0, 0, 5%);
      }
    }
  }
`;

export const Conversations = styled.div`
  & > button {
    font-weight: bold;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    width: 190px;
  }
`;

export const DeleteChatPopover = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  & > div {
    width: 300px;
    padding: 20px;
    background: #FFFCF6;
    border-radius: 4px;
    div {
      margin-top: 8px;
      display: flex;
      justify-content: flex-end;
      button {
        margin-left: 8px;
      }
    }
  }
`;

export const ConversationsTitle = styled.div`
  font-size: 14px;
  line-height: 18px;
  display: flex;
  justify-content: space-between;
  color: ${(props) => props.theme.colors.textMuted};
  font-weight: 600;
`;


export const ConversationSearchSection = styled.div`
  display: flex;
  width: 100%;
  background: white;
  padding: 7px;
  border-radius: 8px;
  & input {
    width: 65%;
    border: none;
    padding: 0 8px;
  }
  & button {
    border-radius: 4px;
    width: 35%;
    cursor: pointer;
    color: ${(props) => props.theme.colors.place};
    background-color: ${(props) => props.theme.colors.primary};
    border: 1px solid ${(props) => props.theme.colors.primary};
    &:disabled {
      opacity: 0.7;
      cursor: wait;
    }
    &:hover {
      color: ${(props) => props.theme.colors.text};
      background-color: #cb5210;
    }
  }
`;

export const InviteWrapper = styled.div`
  position: sticky;
  bottom: -1px;
  left: 0;
  background: #F4EBDA;
  width: 100%;
  & button {
    width: 100%;
  }
`;

export const ConversationList = styled.ul`
  position: relative;
  padding: 0;
  margin: 8px 0 0 0;
  list-style-type: none;
  width: 100%;
  height: 17.5rem;
  overflow-y: auto;
`;
export const ConversationListItem = styled.li<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  background: ${(props) => (props.isActive ? props.theme.colors.text : "")};
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  position: relative;
  & :hover {
    cursor: pointer;
  }
  & > img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: ${(props) =>
    props.isActive
      ? "1px solid #FFFFFF"
      : `1px solid ${props.theme.colors.border}`};
  }

  & > p {
    color: ${(props) =>
    props.isActive ? props.theme.colors.bgBody : props.theme.colors.text};
    font-size: 16px;
    line-height: 21px;
    font-weight: 600;
    padding-left: 8px;
    flex: 1;
    margin: 0;
  }

  & > #dots {
    &:hover {
      background: ${(props) => props.theme.colors.text};
      border-radius: 50%;
      cursor: pointer;
    }
  }

  & > div > svg {
    color: ${(props) =>
    props.isActive ? props.theme.colors.textDimmed : props.theme.colors.text};
  }
`;

export const EmptyLi = styled.li`
  height: 2em;
`;
